// extracted by mini-css-extract-plugin
export default {"container":"ResultModal_container__3BgRx","header":"ResultModal_header__j8se-","body":"ResultModal_body__BGDbH","footer":"ResultModal_footer__lTLSi"};